/**
 * Created by idea on 04/04/2017.
 */
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/startWith';
import {Injectable} from '@angular/core';
import {Actions, Effect} from '@ngrx/effects';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticateService} from '../services/Authenticate.service';
import {ModalInfoService} from '../services/ModalInfo.service';
import * as authen from '../actions/authentication';
import {ToastrService} from 'ngx-toastr';

/**
 * Effects offer a way to isolate and easily test side-effects within your
 * application.
 * The `toPayload` helper function returns just
 * the payload of the currently dispatched action, useful in
 * instances where the current state is not necessary.
 *
 * Documentation on `toPayload` can be found here:
 * https://github.com/ngrx/effects/blob/master/docs/api.md#topayload
 *
 * If you are unfamiliar with the operators being used in these examples, please
 * check out the sources below:
 *
 * Official Docs: http://reactivex.io/rxjs/manual/overview.html#categories-of-operators
 * RxJS 5 Operators By Example: https://gist.github.com/btroncone/d6cf141d6f2c00dc6b35
 */

@Injectable()
export class AuthEffects {
  @Effect() login$ = this.actions$
    // Listen for the 'LOGIN' action
    .ofType(authen.ActionTypes.LOGIN)
    // Map the payload into JSON to use as the request body
    .map((action) => action.payload)
    .switchMap((payload) =>
      this.authenService
        .login(payload)
        // If successful, dispatch success action with result
        .map((res) => {
          console.log('resresres222', res);
          console.log('payload', payload);
          if (res.info.request_change_password == 0) {
            console.log('resresres1111', res);
            const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
            let url = '/evs/dashboard';
            if (returnUrl) {
              url = returnUrl;
            }
            this.router.navigate([url]);
            //location.href = url;
            // location.reload();
            // if (returnUrl) {
            //     url = returnUrl;
            // } else if (res.is_shop) {
            //     url = '/dashboard';
            // }
            // setTimeout(() => {
            // if (!res.user.phone || res.user.phone_verified == false) {
            //     this.router.navigate(['/verify-phone'], {queryParams: {continue: url}});
            //     location.href = '/verify-phone?continue='+url;
            // } else {
            // this.router.navigate([url]);
            // location.href = url;
            // }
            // }, 100);

            // let returnUrl = this.route.snapshot.queryParams['returnUrl'];

            // if(returnUrl){
            //     setTimeout(function(){window.location.replace('/admin'+returnUrl);},100);
            //     //this.router.navigate([returnUrl]);
            // }else{
            //     if(res.is_shop){
            //         setTimeout(function(){window.location.replace('/admin/dashboard');},100);
            //     }else{
            //         setTimeout(function(){window.location.replace('/admin');},100);
            //     }
            //     //this.router.navigate(['']);
            // }
            return new authen.LoginSuccessAction(res.token);
          } else {
            // @ts-ignore
            this.router.navigate(['/reset-password-login'], {queryParams: payload});
            console.log('resresres', res.info.request_change_password);
            return new authen.LoginSuccessAction(res.token)
          }
        })
        // If request fails, dispatch failed action
        .catch((err: any) => {
          console.log(err);
          //this._flashMessagesService.show(err.message, { cssClass: 'alert-danger', timeout: 8000 });
          if (err.token_link) {
            localStorage.setItem('token_link', err.token_link);
            this.router.navigate(['/link-account']);
          }
          this.toastr.error(err.message, 'Đăng nhập thất bại', {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
          return Observable.of(new authen.LoginFailAction(err));
        })
    );

  @Effect() logout$ = this.actions$
    // Listen for the 'LOGIN' action
    .ofType(authen.ActionTypes.LOGOUT)
    // Map the payload into JSON to use as the request body
    .map((action) => action.payload)
    .switchMap(() =>
      Observable.of(this.authenService.logout())
        // If successful, dispatch success action with result
        .map((res) => {
          return new authen.LoginFailAction([]);
        })
        // If request fails, dispatch failed action
        .catch(() => Observable.of(new authen.LoginFailAction([])))
    );

  constructor(
    private actions$: Actions,
    private authenService: AuthenticateService,
    private router: Router,
    private route: ActivatedRoute,
    private mdInfo: ModalInfoService,
    private toastr: ToastrService
  ) {
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/effects/user.ts